import { Box, Card, CardContent, Checkbox } from "@mui/material";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import { useDrag } from "react-dnd";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useMaterialUIController } from "context";

// KPI Card Component
const ItemTypes = { KPI: "kpi" };

const KpiCard = ({ kpi, moveKpi, onEdit, deleteMode, toDeleteKpis, handleSelectKpi }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.KPI,
    item: { id: kpi.kpiNameId, perspectiveId: kpi.perspectiveId },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <Card
      ref={drag}
      onClick={() => onEdit(kpi)}
      sx={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "pointer",
        mb: 1,
        backgroundColor: darkMode ? "#444" : "#ffffff",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        border: darkMode ? "2px solid #333" : "2px solid #ddd",
        "&:hover": {
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 1,
        }}
      >
        {/* KPI Name & Icon */}
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, gap: 1 }}>
          <MDTypography
            variant="body2"
            color={darkMode ? "white" : "black"}
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              flexGrow: 1, // Ensures it takes up remaining space
            }}
          >
            {kpi.kpiName}
          </MDTypography>
          {kpi.kpiFormula === "Regular" ? (
            <AddIcon sx={{ color: "green", fontSize: 20 }} />
          ) : (
            <RemoveIcon sx={{ color: "red", fontSize: 20 }} />
          )}
        </Box>

        {/* Checkbox - Takes Space in Delete Mode */}
        {deleteMode && (
          <Box sx={{ minWidth: 40, display: "flex", justifyContent: "center" }}>
            <Checkbox
              checked={toDeleteKpis.includes(kpi.kpiNameId)}
              onClick={(e) => e.stopPropagation()}
              onChange={() => handleSelectKpi(kpi.kpiNameId)}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

KpiCard.propTypes = {
  kpi: PropTypes.shape({
    kpiNameId: PropTypes.number.isRequired,
    kpiName: PropTypes.string.isRequired,
    perspectiveId: PropTypes.number.isRequired,
    kpiFormula: PropTypes.string.isRequired,
  }).isRequired,
  moveKpi: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired, // Prop for handling edit clicks
  deleteMode: PropTypes.bool.isRequired,
  toDeleteKpis: PropTypes.array.isRequired,
  handleSelectKpi: PropTypes.func.isRequired,
};

export default KpiCard;
